import React, {Suspense, useEffect} from "react";
import {Redirect, Route, Switch, useHistory,} from "react-router-dom";

// importing all the pages
import {getAllCitiesCall} from "../api/ApiCalls";
import {useDispatch, useSelector} from "react-redux";
import {
    updateCitiesRS,
    updateLanguageRS,
} from "../redux/reduxActions/reduxStoreActions";
import {hasAValue} from "../uitls/SharedFunctions";
import ReactGA from "react-ga4";
import {
    Home,
    PartnersOfKnaek,
    ForCompanies,
    ErrorPage,
    KnaekVacancy,
    StoreDiscountsPage,
    ContactPage,
    DownloadPage,
    TermsAndConditions,
    Privacy,
    HowCashbackWorks,
    FAQ,
    StoreDiscountInfo,
    KnaekAboutUs,
    ProfilePage,
    OrderKnaek,
    KnaekReviews,
    Unsubscribe,
    OrderDone,
    UnsubscriptionDone,
    Intro,
    Checkout,
    SendStudentEmail,
    SnipTechOnlineDiscountInfo,
    SnipTechOnlineDiscountsPage,
    FreeDistributionPage,
    ToProfileAfterLogin,
    EmailVerification,
    ThanksForTheReview,
    CouponInfoAndPurchase,
    TermsAndConditionsPlainContent,
} from "./lazyPages";
import useRouteInterceptor from "../uitls/RouteInterceptor";

export default function MyRouts() {
  const dispatch = useDispatch();

  const citiesRS = useSelector((state) => state.citiesRS);
  const authDataRS = useSelector((state) => state.authDataNEWRS);
  const history = useHistory();
  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl);

  if (params.get("language") && ["nl", "en"].includes(params.get("language"))) {
    dispatch(updateLanguageRS(params.get("language")));
    params.delete("language");
    history.replace({ search: params.toString() });
  }

  useEffect(() => {
    // The full discount and location lists are loaded by the pages that need them, see hooks/useBulkData.js
    getCities();
  }, []);

  // Function to track page view with Google Analytics
  const trackPageView = (pathname) => {
    ReactGA.send({ hitType: "page_view", page: pathname, title: "GA4" });
  };

  useEffect(() => {
    if (!history) return;
    trackPageView(history.location.pathname);
    const unregister = history.listen((location, action) => {
      trackPageView(location.pathname);

      // Don't scroll to top if:
      // 1. User is navigating back (POP action)
      // 2. AND there's a saved scroll position (coming back to list from detail)
      const hasSnipTechScrollPosition = sessionStorage.getItem('snipTechListScrollPosition');
      const hasStoreDiscountsScrollPosition = sessionStorage.getItem('storeDiscountsListScrollPosition');
      const isBackNavigation = action === 'POP';
      const shouldPreserveScroll = isBackNavigation && (hasSnipTechScrollPosition || hasStoreDiscountsScrollPosition);

      if (!shouldPreserveScroll) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
    return () => {
      unregister();
    };
  }, [history]);
  useRouteInterceptor();

  return (
    <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route
        path="/studentenkorting/:city_name/:name/:id"
        component={StoreDiscountInfo}
      />
      <Route path="/studentenkorting/:city?" component={StoreDiscountsPage} />
      <Route
        exact
        path="/cashback/studentenkorting/:name/:id"
        component={SnipTechOnlineDiscountInfo}
      />
      <Route exact path="/cashback" component={SnipTechOnlineDiscountsPage}>
        <Redirect to="/cashback/studentenkorting" />
      </Route>
      <Route
        exact
        path="/cashback/studentenkorting"
        component={SnipTechOnlineDiscountsPage}
      />
      <Route path="/partners-van-knaek" component={PartnersOfKnaek} />
      <Route path="/studentenkorting-geven" component={ForCompanies} />
      <Route path="/vacatures" component={KnaekVacancy} />
      <Route path="/contact" component={ContactPage} />
      <Route path="/bestellen/:token" component={OrderDone} />
      <Route path="/checkout/:token" component={Checkout} />
      <Route path="/bestellen" component={OrderKnaek} />
      <Route path="/download-app" component={DownloadPage} />
      <Route path="/algemene-voorwaarden" component={TermsAndConditions} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/privacybeleid" component={Privacy}/>
      <Route path="/reviews" component={KnaekReviews} />
      <Route path="/thank-you-for-rating" component={ThanksForTheReview} />
      <Route path="/opzeggen/:token" component={UnsubscriptionDone} />
      <Route path="/opzeggen" component={Unsubscribe} />
      <Route path="/intro/:name" component={Intro} />
      <Route path="/student-email/:token" component={SendStudentEmail} />
      <Route path="/free-distribution" component={FreeDistributionPage} />
      <Route path="/verify/:token" component={EmailVerification} />
      <Route
        path="/webshop/:id/:payment_id?"
        component={CouponInfoAndPurchase}
      />

      {hasAValue(authDataRS) && (
        <Route path="/account/:name?" component={ProfilePage} />
      )}
      {!hasAValue(authDataRS) && (
        <Route path="/account/:name?" component={ProfilePage}>
          <Redirect to="/" />
        </Route>
      )}

      <Route path="/wie-zijn-wij" component={KnaekAboutUs} />
      <Route path="/FAQ" component={FAQ} />
      <Route path="/how_cashback_works" component={HowCashbackWorks} />
      <Route path="/404" component={ErrorPage} />
      <Route path="/auto-login/:token" component={ToProfileAfterLogin} />



      {/* english routes */}
      <Route exact path="/" component={Home} />
        <Route path="/vacancies" component={KnaekVacancy}/>
      <Route
        path="/student-discounts/:city_name/:name/:id"
        component={StoreDiscountInfo}
      />
        <Route path="/student-discounts/:city?" component={StoreDiscountsPage}/>
      <Route
        exact
        path="/cashback/student-discounts/:name/:id"
        component={SnipTechOnlineDiscountInfo}
      />
      <Route exact path="/cashback" component={SnipTechOnlineDiscountsPage} />
      <Route
        exact
        path="/cashback/student-discounts"
        component={SnipTechOnlineDiscountsPage}
      />
      <Route path="/partners-of-knaek" component={PartnersOfKnaek} />
      <Route path="/give-student-discounts" component={ForCompanies}/>
        <Route path="/vacancies" component={KnaekVacancy}/>
        <Route path="/contact" component={ContactPage}/>
        <Route path="/order/:token" component={OrderDone}/>
        <Route path="/checkout/:token" component={Checkout}/>
        <Route path="/order" component={OrderKnaek}/>
        <Route path="/download-app" component={DownloadPage}/>
        <Route path="/terms-conditions" component={TermsAndConditions}/>
        <Route path="/plain-terms-conditions" component={TermsAndConditionsPlainContent}/>
        <Route path="/privacy" component={Privacy}/>
        <Route path="/privacy-policy" component={Privacy}/>
        <Route path="/reviews" component={KnaekReviews}/>
      <Route path="/thank-you-for-rating" component={ThanksForTheReview} />
      <Route path="/unsubscribe/:token" component={UnsubscriptionDone} />
      <Route path="/unsubscribe" component={Unsubscribe} />
      <Route path="/intro/:name" component={Intro} />
      <Route path="/student-email/:token" component={SendStudentEmail} />
      <Route path="/free-distribution" component={FreeDistributionPage} />
      <Route path="/verify/:token" component={EmailVerification} />
      <Route
        path="/webshop/:id/:payment_id?"
        component={CouponInfoAndPurchase}
      />
      <Route path="/account/:name?" component={ProfilePage} />
        <Route path="/about-us" component={KnaekAboutUs}/>
        <Route path="/faq" component={FAQ}/>
      <Route path="/how-cashback-works" component={HowCashbackWorks} />
      <Route path="/404" component={ErrorPage} />
      <Route path="/auto-login/:token" component={ToProfileAfterLogin} />
      <Route render={() => <Redirect to="/404" />} />
    </Switch>
    </Suspense>
  );

  function getCities() {
    if (citiesRS.length === 0) {
      getAllCitiesCall()
        .then((r) => {
          dispatch(updateCitiesRS(r));
        })
        .catch((error) => { });
    }
  }
}
